const getModuleState = (state) => state.profile;

export const getUserData = (state) => getModuleState(state).data;
export const getUserPoints = (state) => getModuleState(state).data.PuntosDisponibles;
export const getUserTickets = (state) => getModuleState(state).tickets;
export const getUserSubscriptions = (state) => getModuleState(state).subscriptions;
export const getUserPinStatus = (state) => getModuleState(state).pinStatus;